import { render, staticRenderFns } from "./AttendanceDetails.vue?vue&type=template&id=5187679f"
import script from "./AttendanceDetails.vue?vue&type=script&lang=js"
export * from "./AttendanceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5187679f')) {
      api.createRecord('5187679f', component.options)
    } else {
      api.reload('5187679f', component.options)
    }
    module.hot.accept("./AttendanceDetails.vue?vue&type=template&id=5187679f", function () {
      api.rerender('5187679f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/attendance/AttendanceDetails.vue"
export default component.exports